<!--This needs to be re done at somepoint -->
<!--split into login/auth choice/verify compoonents-->
<template>
  <async-loader v-if="resettingAuth"/>
  <app-section-wrap modifier='login' v-else>
    <div column="+1 10 +1">
      <div class="split-card">
        <div class="card-left">
          <h1 class="_text-center _mbs">EyeManage Sign In</h1>
        <p
          v-if="flashMessage"
          class="announcement _mt0 _text-center leaf"
          role="status"
        >
           {{ flashMessage }}
        </p>

        <form @submit.prevent="login(formObject)" method="POST">
          <app-input
            v-if="!showVerify && !showTokenOptions"
            v-model="$v.userId.$model"
            value-key="user-name"
            :required="true"
            :error-message="userIdError"
            :invalid="$v.userId.$invalid"
            label="User ID:"
            modifier=""
          />

          <app-input
            v-if="!showVerify && !showTokenOptions"
            type="password"
            v-model="$v.password.$model"
            value-key="password"
            :required="true"
            :error-message="passwordError"
            :invalid="$v.password.$invalid"
            label="password:"
            modifier=""
          />

          <div container v-if="showTokenOptions && !showVerify" >
            <p
            class="alert _mt0"
            role="alert"
            >
            <strong>
              Please choose your preferred authentication method:
            </strong>
          </p>
            <div column class="_mbxs">
              <input class="mode" type="radio" name="tokenMode" value="EMAIL"
              v-model="tokenMode"
              />
              <label for="email">Email: {{ authValue.emailId }}</label>
            </div>
            <div column  class="_mbxs">
              <input class="mode" type="radio"  name="tokenMode" value="SMS"
              v-model="tokenMode"
              />
              <label for="mobile">Mobile: {{ authValue.phone }} </label>
            </div>
          </div>

          <div v-if="showVerify" class="m-2">
            <!-- TODO replace with content stack-->
            <p class="color-black"><strong>A verification token has been sent to your {{ tokenMode === 'SMS'? 'phone' : 'email' }}</strong></p>
              <p v-if="authFailed && !disabled" class="alert _mt0 lips" role="alert">{{ errorMessage }}</p>
              <p v-else-if="disabled" class="alert _mt0 lips" role="alert">{{ errorMessage }}</p>
              <div  class="form-group verification-container">
                <app-input
                v-model="$v.authToken.$model"
                value-key="auth-token"
                :required="true"
                :error-message="tokenError"
                :invalid="$v.authToken.$invalid"
                label="Verification Code:"
                modifier=""
                />
              </div>
              <div v-if="showTokenOptions" class="_mbxs">
                Having Trouble? <a @click="handleTryAnotherWayClick()"> Try another way </a>
              </div>
          </div>
          <async-button
            v-if="showVerify || showTokenOptions"
            class="_mtxs --sm white"
            :executing="requesting"
            @clicked="requestToken(tokenMode)"
            >
            {{ showVerify ? 'Resend Verification Token' : 'Send Verification Token' }}
          </async-button>

          <p
            class="alert _mt0 lips _text-center"
            v-if="authFailed"
            role="alert"
          >
            {{authErrorMessage}}
          </p>

        <div v-if="authError && authMessage && authMessage.length" class="_flex justify-center">
          <p class="lips text" v-html="authMessage"></p>
        </div>

          <cloud-cannon-content
            class="_mt0 _p0 _text-center color-lips"
            v-if="(lockoutWarningCounter >= lockoutWarningThreshold) && !showTokenOptions && !showVerify"
            role="alert"
            :content-loading="cloudCannonContentLoading"
            :content="cloudCannonContent.lockout_warning"
          />

          <p
            class="alert _mt0 lips _text-center"
            v-if="!isSupportedBrowser"
            role="alert"
          >
            The browser version you are using is not supported on this website. Preferred browsers are Chrome, Firefox or Safari. Please ensure your browser is using the newest version.
          </p>

          <async-button
            :disabled="disable || showTokenOptions && !authToken"
            v-if = "!showTokenOptions || showVerify"
            type="submit"
            class="_mtxs --sm"
            :executing="loggingIn"
          >
          <template #buttonContent>
            <span>sign in</span>
          </template>
          </async-button>
        </form>

      <template v-if="!showVerify && !showTokenOptions">
        <button
          id="forgot-pw"
          class="white --sm"
          @click="forgotPassword"
        >
          forgot password?
        </button>
        <router-link id="forgot-userid" to='/forgot-userid'>Forgot User ID</router-link>
        <router-link id="resend-signup-email" to='/resend-signup-email'>Resend registration email</router-link>
      </template>

      <button
          v-if="showVerify || showTokenOptions"
          class="btn --sm"
          @click="handleBackToLogin()"
        >
        Go Back to Sign In
        </button>

      </div>
        <div class="card-divider"></div>
        <div class="card-right">
          <cloud-cannon-content
          class="_p0"
          :content-loading="cloudCannonContentLoading"
          :content="cloudCannonContent.header"
        />

        </div>
      </div>
      <cloud-cannon-content
        class="_p0 bg-light-gray _mts _text-center"
        :content-loading="cloudCannonContentLoading"
        :content="cloudCannonContent.footer"
      />
    </div>
  </app-section-wrap>
</template>

<script>
  import AsyncLoader from '@molecules/AsyncLoader'
  import AppSectionWrap from '@molecules/SectionWrap.vue'
  import AsyncButton from '@molecules/AsyncButton.vue'
  import { mapGetters } from 'vuex'
  import fetchable from '@mixins/fetchable'
  import loginable from '@mixins/loginable'
  import CloudCannonable from '@mixins/CloudCannonable'
  import AppInput from '@atoms/Input'
  import { required } from 'vuelidate/lib/validators'

  export default {
    mixins: [fetchable, CloudCannonable, loginable],
    beforeCreate () {
      this.$store.dispatch('cacheBuster/NUKE_STATE')
      // if we have a leftover polling handle, clear it.
      let pollHandle = this.$store.getters['attestationPollingHandle']
      if (pollHandle) {
        clearInterval(pollHandle)
      }
    },
    components: {
      AsyncLoader,
      AppSectionWrap,
      AsyncButton,
      AppInput
    },
    validations: {
      userId: {
        required
      },
      password: {
        required
      },
      tokenMode: {
      },
      authToken: {
      // required,
      }

    },
    data() {
      return {
        userId: '',
        password: '',
        authToken: '',
        tokenMode: 'EMAIL',
        fetchers: [
          {
            action: 'cloudCannon/GET_CLOUD_CANNON_CONTENT',
            options: {
              cloudCannonResource: '/login.json'
            },
            config: {
              root: true
            }
          }
        ]
      }
    },
    computed: {

      lockoutWarningThreshold() {
        return this.cloudCannonContent.lockout_warning_threshold
      },

      flashMessage() {
        return this.$route.params.flashMessage
      },

      isSupportedBrowser() {
        return this.isChrome() || this.isFirefox() || this.isSafari()
      },

      disable () {
        return this.$v.$invalid
      },

      userIdError () {
        return this.$v.userId.required ? '' : 'required'
      },

      passwordError () {
        return this.$v.password.required ? '' : 'required'
      },

      tokenError() {
        if (this.showVerify) {
          return this.$v.authToken.required ? '' : 'required'
        } else {
          return 'required'
        }
      },

      ...mapGetters('cacheBuster', ['resettingAuth']),
      formObject() {
        return {
          userId: this.userId,
          password: this.password,
          authToken: this.authToken,
          tokenMode: this.tokenMode
        }
      }
    },
    methods: {
      forgotPassword() {
        this.$router.push({ name: 'forgot-password' })
      },
      handleBackToLogin() {
        // To reset error messages
        // when moving between showverify/show token step
        this.$store.commit('RESET_LOGIN_MESSAGES')
        this.authToken = ''
        this.showVerify = false
        this.showTokenOptions = false
      },
      handleTryAnotherWayClick() {
        this.$store.commit('RESET_LOGIN_MESSAGES')
        this.authToken = ''
        this.showVerify = false
      },
      isChrome() {
        // Chrome 1 - 107
        return navigator.userAgent.indexOf('Chrome') !== -1
      },
      isFirefox() {
        return typeof InstallTrigger !== 'undefined'
      },
      isSafari() {
        // Safari 3.0+ "[object HTMLElementConstructor]"
        // eslint-disable-next-line no-undef
        return /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === '[object SafariRemoteNotification]' })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification))
      },
      browserAgent() {
        return navigator.userAgent
      }
    }
  }
</script>
<style>
input.mode{
  width: 20px !important;
}
</style>
